export class Variables { }

export const SlimScrollOptions: Object = {
    barBackground: '#C9C9C9',
    gridBackground: '#D9D9D9',
    distance: '40px',
    barWidth: '30',
    barMargin: '40',
    barHeight: '10',
    barBorderRadius: '10',
    gridWidth: '2',
    gridMargin: '10',
    alwaysVisible: true,
    allowPageScroll: false,
    noWatch: true,
}



// WEBPACK FOOTER //
// ./src/app/shared/variables.ts